import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { useVerticalNav } from '../../../../Contexts/VerticalNavContext';
import {
  BasicTable,
  CustomPagination,
  NoDataFound,
  TableSkeleton,
} from '../../../../Components';
import { WalletTransactionsHeaderData } from './WalletTransactionsHeaderData';

import useStyles from './styles';
function WalletTransactionsTable({
  filters,
  reportData,
  isLoading,
  setFilters,
}) {
  const { isDarkMode } = useSelector((state) => state.theme);
  const { setStickyBottomBox } = useVerticalNav();

  const dropPagination = useRef(null);
  const stickyPagination = useRef(null);
  const [inputValue, setInputValue] = useState(filters.pageIndex);

  const styles = useStyles();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!stickyPagination.current) return;
          if (entry.isIntersecting) {
            stickyPagination.current.style.display = 'none';
          } else {
            stickyPagination.current.style.display = 'block';
          }
        });
      },
      {
        root: null, // Default to viewport
        threshold: 1, // Adjust this threshold as needed
      }
    );

    // Start observing the dropPagination element
    if (dropPagination.current) {
      observer.observe(dropPagination.current);
    }

    // Cleanup observer on component unmount
    return () => {
      if (dropPagination.current) {
        observer.unobserve(dropPagination.current);
      }
    };
  });

  useEffect(() => {
    setStickyBottomBox(
      <CustomPagination
        hideInMobile
        ref={stickyPagination}
        totalItems={reportData.totalCount}
        itemsPerPage={filters.pageSize}
        currentPage={filters.pageIndex}
        inputValue={inputValue}
        setInputValue={setInputValue}
        onPageChange={(page) =>
          setFilters((prev) => ({ ...prev, pageIndex: page }))
        }
        onItemsPerPageChange={(items) =>
          setFilters((prev) => ({ ...prev, pageSize: items }))
        }
        isSticky
        isLoading={isLoading}
      />
    );

    return () => {
      setStickyBottomBox(null);
    };
  }, [isLoading]);
  return (
    <Box>
      {isLoading ? (
        <TableSkeleton />
      ) : reportData.result?.length ? (
        <>
          <BasicTable
            columns={WalletTransactionsHeaderData(isDarkMode, styles).map(
              (item) => ({
                ...item,
                renderHeader: () => (
                  <Box className={styles.tableHeader}>{item.headerName}</Box>
                ),
              })
            )}
            rowsData={reportData.result?.map((item, index) => ({
              ...item,
              id: index + 1,
            }))}
            rowHeight={84}
          />
          <div ref={dropPagination}>
            <CustomPagination
              hideInMobile
              totalItems={reportData.totalCount}
              itemsPerPage={filters.pageSize}
              currentPage={filters.pageIndex}
              inputValue={inputValue}
              setInputValue={setInputValue}
              isLoading={isLoading}
              onPageChange={(page) =>
                setFilters((prev) => ({ ...prev, pageIndex: page }))
              }
              onItemsPerPageChange={(items) =>
                setFilters((prev) => ({ ...prev, pageSize: items }))
              }
            />
          </div>
        </>
      ) : (
        <NoDataFound
          title={'No data available'}
          subTitle=''
        />
      )}
    </Box>
  );
}

export default WalletTransactionsTable;
